import { useMemo } from 'react';
import { BODY_PAINT_STATE } from '@/consts/bodyAndPaint';

interface PageTitleHookProps {
  status: number;
}
export const usePageTitle = ({ status }: PageTitleHookProps) => {
  const statusList = useMemo(() => Object.keys(BODY_PAINT_STATE), []);
  const title = useMemo(() => {
    switch (statusList[status]) {
      case 'ACCIDENT_ACCEPT':
      case 'CHECK_IN_ACCEPT':
      case 'INSURANCE_APPLY':
      case 'DETERMINED_APPLIES':
      case 'REPAIR_CANCELLED':
        return '予約詳細';
      case 'REPAIR_CLAIM':
      case 'NO_REPAIR':
      case 'DISASSEMBLY':
      case 'REPAIR_HAS_DONE':
      case 'INSPECTION_HAS_DONE':
      case 'DELIVERED_HAS_DONE':
        return '傷・凹み修理';
      default:
        return '傷・凹み修理';
    }
  }, [status, statusList]);
  return { title };
};
